import { AbstractControl, ValidationErrors } from '@angular/forms';

interface StatisticalConfiguration {
  result_Type?: string; formula_Type?: string; acceptance_Type?: string;
  number_Of_Readings?: number | null; measurement_Standard_Uncertainty?: number | null;
  reference_Standard_Uncertainty?: number | null; coverage_Factor?: number | null;
  unit_ID?: number | null;
}

// Mirrors input-domain checks only; the backend remains authoritative for calculations and decisions.
export function icStatisticalInputError(item: StatisticalConfiguration, actualReadings?: number): string {
  if (item.result_Type === 'NUMERIC' && item.formula_Type === 'MEAN') {
    if (item.number_Of_Readings == null || Number(item.number_Of_Readings) < 1 || !item.unit_ID) {
      return 'برای میانگین، تعداد قرائت حداقل یک و واحد اندازه‌گیری مشخص لازم است.';
    }
  }
  if (item.result_Type === 'REPEATABILITY' && (item.formula_Type === 'STD_DEV' || item.acceptance_Type === 'STD_DEV')) {
    if ((item.number_Of_Readings != null && Number(item.number_Of_Readings) < 2)
        || (actualReadings != null && actualReadings < 2)) {
      return 'برای انحراف معیار نمونه حداقل دو قرائت لازم است؛ تعداد قرائت قالب و داده‌های اجرا را بررسی کنید.';
    }
  }
  if (item.result_Type === 'TRUENESS_BIAS') {
    if (item.measurement_Standard_Uncertainty != null && Number(item.measurement_Standard_Uncertainty) < 0) {
      return 'عدم قطعیت استاندارد اندازه‌گیری نمی‌تواند منفی باشد.';
    }
    if (item.reference_Standard_Uncertainty != null && Number(item.reference_Standard_Uncertainty) < 0) {
      return 'عدم قطعیت استاندارد مرجع نمی‌تواند منفی باشد.';
    }
    if (item.coverage_Factor != null && Number(item.coverage_Factor) <= 0) {
      return 'ضریب پوشش باید بزرگ‌تر از صفر باشد.';
    }
  }
  return '';
}

export function icStatisticalConfigurationValidator(control: AbstractControl): ValidationErrors | null {
  if (control.get('active')?.value === false) return null;
  const message = icStatisticalInputError(control.value);
  return message ? { icStatistical: message } : null;
}
